import React, { useEffect, useState, useMemo, useRef } from 'react';
import classNames from 'classnames';
import { Modal } from '../../../components';
import {
  getDistrictList,
  Provice,
  City,
  Region,
} from '../../../utils/lbsHelper';
import styles from './index.module.scss';
import env from '../../../utils/env';

interface CityPickerValue {
  province: string;
  city: string;
  district: string;
  location: {
    lat: number;
    lng: number;
  };
}

export type Value = CityPickerValue;

interface Props {
  open: boolean;
  value: [string, string, string];
  onClose: () => void;
  onChange: (value: CityPickerValue) => void;
  modalClassNames?: string;
  bodyClassNames?: string;
}

export default function CityPicker(props: Props) {
  const { open, value, onChange, modalClassNames, bodyClassNames } = props;
  const prevOpenRef = useRef(open);
  const [currentLevel, setCurrentLevel] = useState(0);
  const [iValue, setIValue] = useState<
    [Provice | null, City | null, Region | null]
  >([null, null, null]);
  const [data, setData] = useState<[Provice[], City[], Region[]]>([[], [], []]);

  useEffect(() => {
    getDistrictList().then(res => {
      setData(res);
    });
  }, []);

  useEffect(() => {
    if (open !== prevOpenRef.current) {
      if (open) {
        const province = value[0];
        const city = value[1];
        const district = value[2];
        let level = 0;

        const pv = data[0].find(item => item.fullname === province) || null;
        let cv: any = null;
        let dv: any = null;

        if (pv) {
          // 只有两集
          if (province === city) {
            cv =
              data[1]
                .slice(pv.cidx[0], pv.cidx[1] + 1)
                .find(item => item.fullname === district) || null;
            dv = null;

            if (cv) {
              level = 1;
            }
          } else {
            cv =
              data[1]
                .slice(pv.cidx[0], pv.cidx[1] + 1)
                .find(item => item.fullname === city) || null;
            if (cv) {
              level = 1;
              if (cv.cidx) {
                dv = data[2]
                  .slice(cv.cidx[0], cv.cidx[1] + 1)
                  .find(item => item.fullname === district);
              }
            }

            if (dv) {
              level = 2;
            }
          }
        }

        setCurrentLevel(level);
        setIValue([pv, cv, dv]);
      }
    }

    prevOpenRef.current = open;
  }, [open, value, data]);

  const showData = useMemo(() => {
    if (currentLevel === 0) {
      return data[0];
    }

    if (currentLevel === 1 && iValue[0]) {
      const province = data[0].find(
        item => iValue[0] && item.fullname === iValue[0].fullname
      );

      if (province) {
        return data[1].filter((it, i) => {
          return i >= province.cidx[0] && i <= province.cidx[1];
        });
      }
    } else if (currentLevel === 2 && iValue[1]) {
      const city = data[1].find(
        item => iValue[1] && item.fullname === iValue[1].fullname
      );

      if (city) {
        const { cidx } = city;

        if (!cidx) return;

        return data[2].filter((it, i) => {
          return i >= cidx[0] && i <= cidx[1];
        });
      }
    }

    return null;
  }, [data, currentLevel, iValue]);

  const themeActive = env.isDiabetesApp ? styles.activeT : styles.active;

  return (
    <Modal
      archor="bottom"
      open={open}
      onClose={props.onClose}
      modalClassNames={modalClassNames}
      bodyClassNames={bodyClassNames}
    >
      <div className={styles.cityPicker}>
        <div className={styles.title}>
          请选择所在地区
          <span className={styles.close} onClick={props.onClose} />
        </div>
        <div className={styles.values}>
          {iValue.map((item, index) => {
            if (index > currentLevel) {
              return null;
            }

            return (
              <span
                // eslint-disable-next-line
                key={index}
                className={classNames(styles.valueItem, {
                  [themeActive]: index === currentLevel,
                })}
                onClick={() => {
                  setCurrentLevel(index);
                  // @ts-ignore
                  setIValue(iValue.map((v, i) => (i <= index ? v : null)));
                }}
              >
                {item ? item.fullname : '请选择'}
              </span>
            );
          })}
        </div>
        <ul className={styles.list} key={currentLevel}>
          {showData &&
            showData.map(item => {
              return (
                <li
                  key={item.fullname}
                  className={classNames({
                    [themeActive]:
                      // @ts-ignore
                      iValue[currentLevel] &&
                      item.fullname === iValue[currentLevel]?.fullname,
                  })}
                  onClick={() => {
                    const nextV = iValue.map((it, index) => {
                      if (index > currentLevel) {
                        return null;
                      }

                      if (index === currentLevel) {
                        return item;
                      }

                      return it;
                    });

                    // @ts-ignore
                    setIValue(nextV);

                    // @ts-ignore
                    if (currentLevel < 2 && item.cidx) {
                      setCurrentLevel(currentLevel + 1);
                    } else {
                      let province = '';
                      let city = '';
                      let district = '';
                      let location: any = {};

                      // @ts-ignore
                      province = nextV[0].fullname;
                      if (nextV[2]) {
                        // @ts-ignore
                        city = nextV[1].fullname;
                        // @ts-ignore
                        district = nextV[2].fullname;
                        location = nextV[2].location;
                      } else {
                        // @ts-ignore
                        city = nextV[0].fullname;
                        // @ts-ignore
                        district = nextV[1].fullname;
                        // @ts-ignore
                        location = nextV[1].location;
                      }

                      onChange({
                        province,
                        city,
                        district,
                        location,
                      });
                    }
                  }}
                >
                  {item.fullname}
                </li>
              );
            })}
        </ul>
      </div>
    </Modal>
  );
}
